import { SERVER_URL } from 'src/constants/serverUrl'
// eslint-disable-next-line no-restricted-imports -- 治験切替時にフル遷移するためのレガシー POST ラッパを継続利用する。legacy 撤去時に createApiClient へ置換予定
import { requestPost } from 'src/legacy_modules/server/request'
import { rotateLoginId } from 'src/utils/rotateLoginId'

export const selectTrialHospitalAndReload = async (params: {
  trialUid: string
  trialHospitalUid?: string
  path?: string
}) => {
  await requestPost<unknown>({
    url: `${SERVER_URL}/accounts/select_trial`,
    params: {
      trial_uid: params.trialUid,
      trial_hospital_uid: params.trialHospitalUid,
    },
  })

  rotateLoginId()
  window.location.href = params.path ?? '/dashboard'
}
